

































































import {Vue, Component, PropSync} from 'vue-property-decorator';
import {WebPushType} from "@/store/push/application/types";
import proxySettingsForm from "@/pages/Pages/Push/proxySettingsForm.vue";
import {isEmpty} from "lodash";

@Component({
  components: {proxySettingsForm}
})
export default class WebPushSettings extends Vue {
  @PropSync('webPushOptions') webPush!: WebPushType;

  get isWebPushProxy(): boolean {
    return !isEmpty(this.webPush.proxy_settings);
  }

  set isWebPushProxy(value: boolean) {
    if (value) {
      this.$set(this.webPush, 'proxy_settings', { host: null });
    } else {
      this.$delete(this.webPush, 'proxy_settings');
    }
  }
}
